var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L22 0L22 22L0 22L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "me-gusta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L22 0L22 22L0 22L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.3320312 3.9101562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8422 9.71094C19.149 9.36848 19.3359 8.91645 19.3359 8.42188C19.3359 7.35582 18.4684 6.48828 17.4023 6.48828L13.6495 6.48828C14.0211 5.36035 14.1797 3.86375 14.1797 3.22223L14.1797 2.57813C14.1797 1.15672 13.023 0 11.6016 0L10.957 0C10.6614 0 10.4036 0.201094 10.3318 0.488125L9.98078 1.89277C9.48879 3.85988 7.92688 6.03023 6.31039 6.42469C6.02723 5.70797 5.32813 5.19922 4.51172 5.19922L0.644531 5.19922C0.28875 5.19922 0 5.48797 0 5.84375L0 17.4453C0 17.8011 0.28875 18.0898 0.644531 18.0898L4.51172 18.0898C5.28043 18.0898 5.94559 17.6391 6.25711 16.9877L8.47172 17.7259C9.19574 17.9674 9.95027 18.0898 10.7138 18.0898L16.1133 18.0898C17.1793 18.0898 18.0469 17.2223 18.0469 16.1563C18.0469 15.9049 17.9987 15.6643 17.9111 15.4438C18.7309 15.22 19.3359 14.4684 19.3359 13.5781C19.3359 13.0836 19.149 12.6315 18.8422 12.2891C19.149 11.9466 19.3359 11.4946 19.3359 11C19.3359 10.5054 19.149 10.0534 18.8422 9.71094L18.8422 9.71094ZM5.15625 16.1563C5.15625 16.5116 4.86707 16.8008 4.51172 16.8008L1.28906 16.8008L1.28906 6.48828L4.51172 6.48828C4.86707 6.48828 5.15625 6.77746 5.15625 7.13281L5.15625 16.1563L5.15625 16.1563ZM16.1133 10.3555L17.4023 10.3555C17.7577 10.3555 18.0469 10.6446 18.0469 11C18.0469 11.3554 17.7577 11.6445 17.4023 11.6445L16.1133 11.6445C15.7575 11.6445 15.4687 11.9333 15.4687 12.2891C15.4687 12.6448 15.7575 12.9336 16.1133 12.9336L17.4023 12.9336C17.7577 12.9336 18.0469 13.2228 18.0469 13.5781C18.0469 13.9335 17.7577 14.2227 17.4023 14.2227L16.1133 14.2227C15.7575 14.2227 15.4687 14.5114 15.4687 14.8672C15.4687 15.223 15.7575 15.5117 16.1133 15.5117C16.4686 15.5117 16.7578 15.8009 16.7578 16.1563C16.7578 16.5116 16.4686 16.8008 16.1133 16.8008L10.7138 16.8008C10.0891 16.8008 9.4716 16.7007 8.87906 16.503L6.44531 15.6918L6.44531 7.71633C7.45637 7.52426 8.44594 6.88402 9.33926 5.83602C10.2115 4.8125 10.9188 3.45555 11.2312 2.20559L11.4602 1.28906L11.6016 1.28906C12.3123 1.28906 12.8906 1.86742 12.8906 2.57813L12.8906 3.22223C12.8906 4.08762 12.6199 5.7475 12.2736 6.48828L10.957 6.48828C10.6012 6.48828 10.3125 6.77703 10.3125 7.13281C10.3125 7.48859 10.6012 7.77734 10.957 7.77734L17.4023 7.77734C17.7577 7.77734 18.0469 8.06652 18.0469 8.42188C18.0469 8.77723 17.7577 9.06641 17.4023 9.06641L16.1133 9.06641C15.7575 9.06641 15.4687 9.35516 15.4687 9.71094C15.4687 10.0667 15.7575 10.3555 16.1133 10.3555L16.1133 10.3555Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.9101562 18.132812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.644531C0 0.288567 0.288567 0 0.644531 0C1.0005 0 1.28906 0.288567 1.28906 0.644531C1.28906 1.0005 1.0005 1.28906 0.644531 1.28906C0.288567 1.28906 0 1.0005 0 0.644531Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.933594 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.644531 0C0.288578 0 0 0.288578 0 0.644531L0 1.97656C0 2.33252 0.288578 2.62109 0.644531 2.62109C1.00048 2.62109 1.28906 2.33252 1.28906 1.97656L1.28906 0.644531C1.28906 0.288578 1.00048 0 0.644531 0L0.644531 0Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.832031 1.7421875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01177 1.10028L1.10028 0.188783C0.848611 -0.0629277 0.440494 -0.0629277 0.188783 0.188783C-0.0629282 0.440494 -0.0629282 0.848568 0.188783 1.10028L1.10028 2.01177C1.35195 2.26344 1.76011 2.26349 2.01177 2.01177C2.26349 1.76006 2.26349 1.35199 2.01177 1.10028L2.01177 1.10028Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.124023 1.7421875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01178 0.188783C1.76011 -0.0629277 1.35199 -0.0629277 1.10028 0.188783L0.188782 1.10024C-0.0629274 1.35195 -0.0629274 1.76002 0.188782 2.01173C0.44045 2.26344 0.848569 2.26349 1.10028 2.01178L2.01178 1.10028C2.26349 0.848568 2.26349 0.440494 2.01178 0.188783L2.01178 0.188783Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLike);
export default __webpack_public_path__ + "static/media/greenLike.0497a9ff2bd74358d6463c75fe31f22a.svg";
export { ForwardRef as ReactComponent };